import Swal from "sweetalert2";
import axios from "axios";
import { familyTreeUrl, reqUrl } from "./webConfig";

let isIncFamilyTree;
let isIncMainBanner;
let isPasswordResetPage;

// Dynamically load Main Banner module
async function loadMainBannerModule() {
  if (isIncMainBanner) {
    const MainBannerModule = await import("./modules/mainBanner");
    new MainBannerModule.default();
  }
}

// Dynamiclly load Family Tree module
async function loadFamilyTreeModule() {
  if (isIncFamilyTree) {
    const FamilyTreeModule = await import("./modules/familyTree/familyTree");
    new FamilyTreeModule.default();
  }
}

function validateInputs(formInputs) {

  let isValid = true;
  let password = "";
  let confirmPassword = "";
  let passwordInput, confirmPasswordInput, confirmPasswordMessage;

  for (const input of formInputs) {
    const validationMessageElement = input.nextElementSibling; // Assuming validation message node is immediately after the input
    validationMessageElement.textContent = "";
    input.classList.remove("error");
    validationMessageElement.classList.add("hidden");

    // Collect the input references and passwords for comparison
    if (input.id === 'resetPasswordNewPassword') {
      password = input.value;
      passwordInput = input;
    } else if (input.id === 'resetPasswordNewConfirmPassword') {
      confirmPassword = input.value;
      confirmPasswordInput = input;
      confirmPasswordMessage = confirmPasswordInput.nextElementSibling;
      confirmPasswordMessage.classList.add("hidden");
    }

    // Validate the email input
    if (input.type === "email" && !this.validateEmail(input.value)) {
      input.classList.add("error");
      validationMessageElement.classList.remove("hidden");
      validationMessageElement.textContent = "Please enter a valid email address.";
      isValid = false; // Set to false on validation fail
    }

    // Validate if the input is required and empty
    if (input.required && input.value.trim() === "") {
      input.classList.add("error");
      validationMessageElement.classList.remove("hidden");
      validationMessageElement.textContent = "This field is required.";
      isValid = false; // Set to false on validation fail
    }
  }

  // Validate that passwords match
  if (password && confirmPassword && password !== confirmPassword) {
    passwordInput.classList.add("error");
    confirmPasswordInput.classList.add("error");
    confirmPasswordMessage.classList.remove("hidden");
    confirmPasswordMessage.textContent = "Passwords do not match.";
    isValid = false; // Set to false on validation fail
  }

  return isValid; // Return the final validity of the form
}

async function loadPasswordReset() {
  const resetPasswordForm = document.querySelector("#resetPasswordForm");
  if (resetPasswordForm) {
    const userId = new URLSearchParams(window.location.search).get("userId");
    const formInputs = resetPasswordForm.querySelectorAll("[data-input]");
    resetPasswordForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const responseSelector = resetPasswordForm.querySelector(".response-msg");

      if (responseSelector) responseSelector.classList.add("hidden");
      // Validate inputs
      const isValid = validateInputs(formInputs);
      if (!isValid) {
        return;
      }

      let formData = {};
      formInputs.forEach((input) => {
        formData[input.name] = input.value;
      });

      axios
        .post(`${reqUrl}Setpassword`, {
          userId: userId,
          oldPassword: formData.resetPasswordTempPassword,
          newPassword: formData.resetPasswordNewPassword,
        })
        .then((response) => {
          if (response.data.success == false) {
            if (response.data.statusMessage && responseSelector) {
              responseSelector.classList.remove("hidden");
              responseSelector.textContent = response.data.statusMessage;
            }
          } else if (response.data.success == true) {
            window.location = `${familyTreeUrl}?passwordHasChanged`;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
}

function handleGatedLink(el) {
  Swal.fire({
    title: el.dataset.title,
    text: el.dataset.text,
    showCancelButton: true,
    confirmButtonColor: "#3498db",
    cancelButtonColor: "#34495e",
    confirmButtonText: el.dataset.confirm,
    cancelButtonText: el.dataset.cancel,
    customClass: {
      htmlContainer: "leading-relaxed",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      window.location = el.href;
    }
  });
}

function init() {
  isIncFamilyTree = document.body.classList.contains("inc-family-tree");
  isIncMainBanner = document.body.classList.contains("inc-main-banner");
  isPasswordResetPage = document.body.classList.contains("page-reset-password");

  if (isIncFamilyTree) loadFamilyTreeModule();
  if (isIncMainBanner) loadMainBannerModule();
  if (isPasswordResetPage) loadPasswordReset();

  const btnScreenNavOpen = document.querySelectorAll("[data-btnScreenNavOpen]");
  const btnScreenNavClose = document.querySelector("#btnScreenNavClose");
  const btnScreenDropdownOpen = document.querySelector("#btnScreenDropdownOpen");
  const btnScreenDropdownClose = document.querySelector("#btnScreenDropdownClose");

  if (btnScreenNavOpen) {
    btnScreenNavOpen.forEach((el) => {
      el.addEventListener("click", () => {
        document.querySelector("#screenNav").classList.add("screen-nav--open");
      });
    });
  }

  if (btnScreenNavClose) {
    btnScreenNavClose.addEventListener("click", () => {
      document.querySelector("#screenNav").classList.remove("screen-nav--open");
    });
  }

  if (btnScreenDropdownOpen) {
    btnScreenDropdownOpen.addEventListener("click", () => {
      document.querySelector("#screenDropdown").style.height = "100%";
    });
  }

  if (btnScreenDropdownClose) {
    btnScreenDropdownClose.addEventListener("click", () => {
      document.querySelector("#screenDropdown").style.height = "0%";
    });
  }

  const gatedLink = document.querySelectorAll("a[data-gated]");
  if (gatedLink) {
    gatedLink.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        handleGatedLink(el);
      });
    });
  }
}

// Function to run when the DOM is ready
function onDOMContentLoaded() {
  init();
}

// Initialize the code when the DOM is ready
if (document.readyState === "complete") {
  onDOMContentLoaded();
} else {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
}
